module.exports = __webpack_public_path__ + "img/ic-flag-paraguay.fd3fa5f7.svg";